import axios from "axios";
import React from "react";
import { alertRef } from "../../../../App";
import Dropdown from "../../../../Components/Dropdown/Dropdown";
import { Button } from "../../../../Components/StyledComponents";
import SetSMS from "../../Components/SetSMS/SetSMS";
import SetTarget from "../../Components/SetTarget/SetTarget";
import './VisitTarget.scss';

const VisitTarget = () => {
    const [ days, setDays ] = React.useState('All')//방문 기간
    const [ title, setTitle ] = React.useState('');//문자 제목
    const [ text, setText ] = React.useState('');//문자 내용
    const [ coupon, setCoupon ] = React.useState('');//발송할 쿠폰 id
    const [ gender, setGender ] = React.useState([])//상세 타겟 성별
    const [ age, setAge ] = React.useState([])//상세타겟 연령
    const [ targetSort, setTargetSort ] = React.useState('');//타겟 인웟 정렬 방식
    const [ reqCount, setReqCount ] = React.useState(0);//타겟 인원 수
    const [ couponInfo, setCouponInfo ] = React.useState({})//쿠폰 정보

    const [ targetCount, setTargetCount ] = React.useState(0);//추출한 타겟 수

    //타겟 추출 get
    const getTarget = () => {
        axios.post('/api/sms/filter',{
            Type : 'LastVisit',
            PointType : 'Remain',
            FilterRange : { Min : 'All', Max : 'All' },
            Day : days,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 200){
                setTargetCount(data.data.TargetCount)
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `다시 시도해 주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })  
        })
    }

    //타겟 문자 발송
    const sendTargetSMS = () => {
        axios.put('/api/sms/filter',{
            Title : title,
            Body : text,
            Coupon : coupon,
            Type : 'LastVisit',
            PointType : 'Remain',
            FilterRange : { Min : 'All', Max : 'All' },
            Day : days,
            DateRange : { Start : 'All', End : 'All'},
            Detail : {
                Age : age,
                Gender : gender,
                Limit : Number(reqCount),
                Sort : targetSort
            }
        })
        .then((data) => {
            if(data.status === 204 ){
                alertRef.current.showAlert({ title : `문자 발송이 완료 되었습니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }else if(data.status === 200){
                alertRef.current.showAlert({ title : `보유 벨이 부족합니다.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
            }
        })
        .catch(() => {
            alertRef.current.showAlert({ title : `네트워크 상태 혹은 보유벨을 확인해주세요.`, isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
        })
    }

    return (
        <div className="visit">
            <div className="box">
                <p className="title">방문일</p>
                <div className="row">
                    <Dropdown
                        width={137}
                        options={[
                            { key : '전체', value : 'All'},
                            { key : '180일', value : 180},
                            { key : '60일', value : 60},
                            { key : '30일', value : 30},
                            { key : '10일', value : 10},
                        ]}
                        value={days === 'All' ? '전체' : days}
                        onItemClick={(val) => setDays(val)}
                        prefix={days !== 'All' && "일"}
                    />
                    <p className="text">기간 동안 방문한 고객</p>
                </div>
            </div>

            <SetTarget gender={gender} setGender={setGender} age={age} setAge={setAge} targetSort={targetSort} setTargetSort={setTargetSort} reqCount={reqCount} setReqCount={setReqCount} getTarget={getTarget} targetCount={targetCount}/>

            <SetSMS smsTitle={title} setSMSTitle={setTitle} smsText={text} setSMSText={setText} coupon={coupon} setCoupon={setCoupon} couponInfo={couponInfo} setCouponInfo={setCouponInfo}/>

            <Button variant='outline' disabled={ title.trim() == '' || text.trim() === '' || targetCount === 0} className="send-btn" onClick={() => alertRef.current.showAlert({ title : `타겟 문자를 발송할까요?`, isConfirm : true, confirmText : '확인', isCancel : true, cancelText : '취소', onConfirm : () => {alertRef.current.hideAlert();sendTargetSMS()} })}>
                문자 발송하기
            </Button>
        </div>
    )
}

export default VisitTarget;